import { render, staticRenderFns } from "./addCustomerNew.vue?vue&type=template&id=7a5f054c&scoped=true"
import script from "./addCustomerNew.vue?vue&type=script&lang=js"
export * from "./addCustomerNew.vue?vue&type=script&lang=js"
import style0 from "./addCustomerNew.vue?vue&type=style&index=0&id=7a5f054c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5f054c",
  null
  
)

export default component.exports